/**
 * A flat legend (i.e. nothing) for a form.
 *
 * @returns A blank legend.
 */export const FlatLegend=()=>{return null};